import { BhImage } from 'models/BhImage';
import Image from 'components/Shared/Image';
import styles from './styles.scss';
import { flattenStyles } from 'utils';
import cn from 'classnames';

type AppearanceType = 'small' | 'medium' | 'large';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type OverrideStyleInterface = any;
const _styles: OverrideStyleInterface = styles;

interface Size {
  [key: string]: { width: number; height: number };
}
const sizes: Size = {
  small: { width: 200, height: 20 },
  medium: { width: 100, height: 200 },
  large: { width: 200, height: 400 }
};

interface OwnProps extends BhImage {
  className?: string;
  appearance: AppearanceType;
}

export default ({ className, appearance, ...brand }: OwnProps) => (
  <Image
    className={cn(flattenStyles(_styles)(appearance), className)}
    {...brand}
    {...sizes[appearance]}
    alt={brand.name}
  />
);
